import { Type } from "class-transformer";
import { computed, observable } from "mobx";
import LanguageCode from "./languageCode";

export enum SystemComponent {
  "PAY_GATE" = "paygate",
  "ISDS" = "isds",
  "ESHOP" = "eshop",
  "OTHER" = "other",
}

class SystemComponentOutageLocalizationResponse {
  @observable
  languageCode: LanguageCode;

  @observable
  description: string;
}

export default class Outage {
  @Type(() => Date)
  @observable
  validSince: Date;

  @Type(() => Date)
  @observable
  validUntil?: Date;

  @Type(() => Date)
  @observable
  visibleSince: Date;

  @observable
  systemComponentId: string;

  @observable
  systemComponentCode: SystemComponent | string;

  @observable
  description?: string;

  @observable
  @Type(() => SystemComponentOutageLocalizationResponse)
  systemComponentOutageLocalizations?: SystemComponentOutageLocalizationResponse[];

  @computed
  get id() {
    return `${this.systemComponentId}-${this.validSince.toISOString()}`;
  }
}
